export enum Constants {
  COUNTRIES_FETCH_REQUEST = '@@countries/COUNTRIES_FETCH_REQUEST',
  COUNTRIES_FETCH_SUCCESS = '@@countries/COUNTRIES_FETCH_SUCCESS',
  COUNTRIES_FETCH_FAILURE = '@@countries/COUNTRIES_FETCH_FAILURE',
}
